export const cpfMask = (document) => {
  document = document.toString().replace(/\D/g, "");
  document = document.substring(0, 11);
  document = document.replace(/(\d{3})(\d)/, "$1.$2")
  document = document.replace(/(\d{3})(\d)/, "$1.$2")
  document = document.replace(/(\d{3})(\d{1,2})$/, "$1-$2")

  return document
}

export const cnpjMask = (document) => {
  document = document.toString().replace(/\D/g, "");
  document = document.substring(0, 14);
  document = document.replace(/^(\d{2})(\d)/, "$1.$2")
  document = document.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
  document = document.replace(/\.(\d{3})(\d)/, ".$1/$2")
  document = document.replace(/(\d{4})(\d)/, "$1-$2")

  return document;
}

export const cpfCnpjMask = (document) => {
  if (document.length === 18) return document.slice(0, 18);
  if (document.length <= 14) return cpfMask(document);
  return cnpjMask(document);
}

export const phoneMask = (value) => {
  if (!value) return ""

  value = value.replace(/\D/g, '');

  if (value.length > 11) {
    value = value.substring(0, 11);
  }

  if (value.length > 10) {
    value = value.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  } else if (value.length > 6) {
    value = value.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
  } else if (value.length > 2) {
    value = value.replace(/(\d{2})(\d{0,4})/, "($1) $2");
  } else {
    value = value.replace(/(\d{0,2})/, "($1");
  }

  return value;
}

export const dateMask = (date) => {
  date = date.replace(/\D/g, '');
  date = date.replace(/^(\d{2})(\d)/, '$1/$2');
  date = date.replace(/^(\d{2})\/(\d{2})(\d)/, '$1/$2/$3');
  date = date.replace(/^(\d{2})\/(\d{2})\/(\d{4})/, '$1/$2/$3');
  date = date.slice(0, 10);

  return date;
}

export const formatThousands = (value) => {
  value = value.replace(/\D/g, '');
  value = value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return value;
}